
import { useMemo } from "react";
import { Flight } from "@/types/flight";

interface FlightStatusSummaryProps {
  flights: Flight[];
}

export function FlightStatusSummary({ flights }: FlightStatusSummaryProps) {
  // Memoize status calculations
  const statusCounts = useMemo(() => {
    const onTime = flights.filter(f => f.status === "On Time").length;
    const delayed = flights.filter(f => f.status === "Delayed").length;
    const cancelled = flights.filter(f => f.status === "Cancelled").length;
    
    return { onTime, delayed, cancelled };
  }, [flights]);
  
  return (
    <div className="flex flex-wrap justify-around border-b py-1 text-center">
      <div>
        <span className="text-sm text-foreground mr-2">Total:</span>
        <span className="font-medium">{flights.length} flights</span>
      </div>
      <div>
        <span className="text-sm text-foreground mr-2">On Time:</span>
        <span className="font-medium text-green-600">{statusCounts.onTime}</span>
      </div>
      <div>
        <span className="text-sm text-foreground mr-2">Delayed:</span>
        <span className="font-medium text-amber-600">{statusCounts.delayed}</span>
      </div>
      <div>
        <span className="text-sm text-foreground mr-2">Cancelled:</span>
        <span className="font-medium text-red-600">{statusCounts.cancelled}</span>
      </div>
    </div>
  );
}
